import cta_en from './cta_en.json'
import cta_fr from './cta_fr.json'
import forms_en from './forms_en.json'
import forms_fr from './forms_fr.json'
import common_en from './common_en.json'
import common_fr from './common_fr.json'
import contactInfo_en from './contact-info_en.json'
import contactInfo_fr from './contact-info_fr.json'
import helpGuide_en from './help-guide_en.json'
import helpGuide_fr from './help-guide_fr.json'

const lcr_resources = {
  en: {
    ...cta_en,
    ...forms_en,
    ...common_en,
    ...contactInfo_en,
    ...helpGuide_en,
  },
  fr: {
    ...cta_fr,
    ...forms_fr,
    ...common_fr,
    ...contactInfo_fr,
    ...helpGuide_fr,
  },
}

export default lcr_resources
